import React, { useEffect, useState } from 'react';
import { InputNumber, Select, Typography } from 'antd';

export default function AmountFilter({ setFilter }) {
  const [amount, setAmount] = useState(null);
  const [compareType, setCompareType] = useState('greater');

  const handleAmountChange = (value) => {
    if (value) {
      setAmount(value);
    } else {
      setAmount(null);
    }
  };

  const handleCompareTypeChange = (value) => {
    setCompareType(value);
  };

  useEffect(() => {
    setFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      delete newFilter.amount;
      if (amount) {
        switch (compareType) {
          case 'greater':
            newFilter.amount = { $gt: amount };
            break;
          case 'less':
            newFilter.amount = { $lt: amount };
            break;
          default:
            break;
        }
      }
      return newFilter;
    });
  }, [amount, compareType, setFilter]);

  const selectBefore = (
    <Select defaultValue={compareType} onChange={handleCompareTypeChange}>
      <Select.Option value="greater">大於</Select.Option>
      <Select.Option value="less">小於</Select.Option>
    </Select>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Typography.Text>金額：</Typography.Text>
      <InputNumber
        value={amount}
        min={0}
        onChange={handleAmountChange}
        addonBefore={selectBefore}
        style={{ width: '200px' }}
      />
    </div>
  );
}
